(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("taxJarSalesTaxV2", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/connections/taxJar/taxJarSalesTaxV2View.html",
            controller: ["$state", "connectionsResource", "messageService", TaxJarSalesTaxV2Ctrl],
            controllerAs: "vm"
        };
        function TaxJarSalesTaxV2Ctrl($state, connectionsResource, messageService) {
            var vm = this;
            connectionsResource.getTaxJarSalesTaxV2ViewModel(function (result) {
                vm.model = result;
            }, function (error) {
                messageService.error(error);
            });
            vm.test = function () {
                delete vm.connectionSuccess;
                connectionsResource.postTaxJarSalesTaxV2TestConnection(vm.model, function () {
                    vm.connectionSuccess = true;
                }, function () {
                    vm.connectionSuccess = false;
                });
            };
            vm.save = function () {
                if (vm.saving)
                    return;
                if (vm.form.$valid) {
                    vm.saving = true;
                    connectionsResource.postTaxJarSalesTaxV2(vm.model, function (result) {
                        vm.model = result;
                        vm.saving = false;
                        messageService.success("common.changesSaved");
                        vm.form.$setPristine();
                        vm.form.$setUntouched();
                    }, function (error) {
                        messageService.error(error);
                        vm.saving = false;
                    });
                }
                else
                    vm.showErrors = true;
            };
            vm.cancel = function () {
                $state.go("main.settings.connections");
            };
        }
    });
}());
